// CustomMapLayer.tsx
import { useEffect } from "react";
import { useMap } from "react-leaflet";
// @ts-ignore
import * as L from "leaflet";
import "leaflet.heat";
import "./Heatmap.css";

export interface HeatPoint {
  lat: number;
  lng: number;
  intensity?: number;
}

interface Props {
  points: HeatPoint[];
  radius?: number;
  blur?: number;
  max?: number;
  gradient?: { [key: number]: string };
}

const CustomMapLayer: React.FC<Props> = ({
  points,
  radius = 25,
  blur = 15,
  max = 1.0,
  gradient,
}) => {
  const map = useMap();

  useEffect(() => {
    if (!points || points.length === 0) return;

    let heatLayer: L.Layer | null = null;
    let rafId: number | null = null;
    let cancelled = false;
    let attempts = 0;

    const addWhenSized = () => {
      if (cancelled) return;
      attempts += 1;

      const size = map.getSize();
      // Leaflet.heat throws if the internal canvas is 0x0.
      // This can happen when the map container is not yet laid out.
      if (size.x === 0 || size.y === 0) {
        if (attempts < 120 && typeof window !== "undefined") {
          rafId = window.requestAnimationFrame(addWhenSized);
        }
        return;
      }

      // Ensure Leaflet recalculates the map size before drawing.
      map.invalidateSize();

      const heatData = points.map((p) => [p.lat, p.lng, p.intensity ?? 1]);
      // @ts-ignore
      heatLayer = L.heatLayer(heatData, { radius, blur, max, gradient }).addTo(map);
    };

    addWhenSized();

    return () => {
      cancelled = true;
      if (rafId && typeof window !== "undefined") window.cancelAnimationFrame(rafId);
      if (heatLayer) map.removeLayer(heatLayer);
    };
  }, [map, points, radius, blur, max, gradient]);

  return null;
};

export default CustomMapLayer;

